<template>
  <div style="display: inline;">
    <!-- table表格 -->
    <yi_curd_table v-bind="$attrs" :name="$options.name" ref="yt" getUrl="/web/tool/page" @afterGet="afterGet" getKey="rows" :columns="columns">
      <!-- 搜索框插槽 -->
      <template #conditions>
        <el-form size="mini" :inline="true" :model="yt.conditions" class="demo-form-inline">
          <el-form-item :label="$t('suoshuzuzhi')">
            <yi_data_select :type="'organization'" :ids.sync="yt.conditions.orgId"></yi_data_select>
          </el-form-item>
          <el-form-item :label="$t('gongzhuangleixing')">
            <yi_dictionary_select :type="'CUSTOMER_TOOL_TYPE'" :ids.sync="yt.conditions.toolType"></yi_dictionary_select>
          </el-form-item>
          <el-form-item :label="$t('gongzhuangxinghao')">
            <el-input v-model="yt.conditions.toolSpec"></el-input>
          </el-form-item>
          <el-form-item :label="$t('gongzhuangbianhao')">
            <el-input v-model="yt.conditions.toolNo"></el-input>
          </el-form-item>
          <el-form-item :label="$t('gongzhuangmingcheng')">
            <el-input v-model="yt.conditions.toolName"></el-input>
          </el-form-item>
          <el-form-item :label="$t('shiyongzhuangtai')">
            <yi_dictionary_select type="TOOL_USAGE_STATUS" :ids.sync="yt.conditions.usageStatus"> </yi_dictionary_select>
          </el-form-item>
          <el-form-item>
            <el-button @click="yt.get(1)" type="primary" plain="plain">
              {{ $t('sousuo') }}
            </el-button>
            <el-button @click="yt.clear({ orderBy: 'createTime desc' })">{{ $t('chongzhi') }} </el-button>
            <yi_curd_expand_button></yi_curd_expand_button>
          </el-form-item>
        </el-form>
      </template>
      <!-- 重量（可弹窗查看） -->
      <template #zhongliang(KG)="scope">
        <el-row :gutter="10">
          <el-col :span="0.1">
            <el-button type="text" @click="yt.showEditDialog('chengzhongjilu', scope.row, '90%')">
              {{ scope.row.weight }}
            </el-button>
          </el-col>
        </el-row>
      </template>
      <!-- 左侧按钮插槽 -->
      <template #buttonsL>
        <el-button
          size="mini"
          @click="
            yt.showEditDialog('xinzeng', null, 'w2');
            setDefaultValue();
          "
          type="primary"
          v-if="utils.checkPower('web_base_tool_add_button')"
          v-burylog="{ functionType: '用户行为', logType: '按钮点击', startData: { s1: '工装台账-新增' } }"
        >
          {{ $t('xinzeng') }}
        </el-button>
        <el-button size="mini" @click="yt.showEditDialog('daoru', null, '1400px')" v-if="utils.checkPower('web_base_tool_import')" v-burylog="{ functionType: '用户行为', logType: '按钮点击', startData: { s1: '工装台账-导入' } }">
          {{ $t('daorugongzhuangtaizhang') }}
        </el-button>
        <el-button size="mini" @click="yt.showEditDialog('daorugongzhuangchanpinguanxi', null, '1400px')" v-if="utils.checkPower('web_base_tool_adapt_product_import')" v-burylog="{ functionType: '用户行为', logType: '按钮点击', startData: { s1: '工装台账-导入工装-产品关系' } }">
          {{ $t('daorugongzhuangchanpinguanxi') }}
        </el-button>
        <el-button size="mini" @click="exportExcel" v-if="utils.checkPower('web_base_tool_adapt_product_export')" v-burylog="{ functionType: '用户行为', logType: '按钮点击', startData: { s1: '工装台账-导出工装-产品关系' } }">
          {{ $t('daochugongzhuangchanpinguanxi') }}
        </el-button>
      </template>
      <!-- 右侧按钮插槽 -->
      <template #buttonsR>
        <el-button size="mini" icon="yicon yicon-config_column" :title="$t('peizhilie')" @click="yt.showColumnsDialog()"></el-button>
      </template>
      <!-- 操作列 -->
      <template #caozuo="scope">
        <el-row :gutter="10">
          <el-col :span="0.1" v-if="utils.checkPower('web_base_tool_qrcode_button')">
            <el-button type="text" style="color: #67C23A;" @click="printToolNo(scope.row)" v-burylog="{ functionType: '用户行为', logType: '按钮点击', startData: { s1: '工装台账-二维码' } }">
              {{ $t('erweima') }}
            </el-button>
          </el-col>
          <el-col :span="0.1" v-if="utils.checkPower('web_base_tool_adapt_object_button')">
            <el-button type="text" @click="yt.showEditDialog('shipeiduixiang', scope.row, '70%')" v-burylog="{ functionType: '用户行为', logType: '按钮点击', startData: { s1: '工装台账-适配对象' } }">
              {{ $t('shipeiduixiang') }}
            </el-button>
          </el-col>
          <el-col :span="0.1" v-if="utils.checkPower('web_base_tool_update_button')">
            <el-button
              type="text"
              @click="
                yt.showEditDialog('bianji', scope.row, 'w2');
                setEditDefaultValue();
              "
              v-burylog="{ functionType: '用户行为', logType: '按钮点击', startData: { s1: '工装台账-编辑' } }"
            >
              {{ $t('bianji') }}
            </el-button>
          </el-col>
          <el-col :span="0.1" v-if="utils.checkPower('web_base_tool_delete_button')">
            <el-button type="text" class="font-color-danger" @click="yt.remove(scope.row, '/web/tool/delete')" v-burylog="{ functionType: '用户行为', logType: '按钮点击', startData: { s1: '工装台账-删除' } }">
              {{ $t('shanchu') }}
            </el-button>
          </el-col>
        </el-row>
      </template>
    </yi_curd_table>
    <el-dialog :show-close="true" :title="$t(yt.editObj.action)" :visible.sync="yt.isShowEditDialog" :width="yt.dialogWidth" :close-on-click-modal="false" append-to-body="append-to-body">
      <!-- 新增或编辑 -->
      <template v-if="yt.editObj.action == 'xinzeng' || yt.editObj.action == 'bianji'">
        <el-form :inline="true" ref="form" size="mini" :label-width="yt.formLabelWidth">
          <el-form-item :label="$t('gongzhuangleixing')" required>
            <yi_dictionary_select :type="'CUSTOMER_TOOL_TYPE'" :ids.sync="yt.editObj.toolType"></yi_dictionary_select>
          </el-form-item>
          <el-form-item :label="$t('gongzhuangbianhao')" required v-if="yt.editObj.action == 'xinzeng'">
            <el-input v-model="yt.editObj.toolNo"></el-input>
          </el-form-item>
          <el-form-item class="noborder" :label="$t('gongzhuangbianhao')" required v-if="yt.editObj.action == 'bianji'">
            <el-input disabled v-model="yt.editObj.toolNo"></el-input>
          </el-form-item>
          <el-form-item :label="$t('gongzhuangxinghao')">
            <el-input v-model="yt.editObj.toolSpec"></el-input>
          </el-form-item>
          <el-form-item :label="$t('gongzhuangmingcheng')" required>
            <el-input v-model="yt.editObj.toolName"></el-input>
          </el-form-item>
          <el-form-item :label="$t('suoshuzuzhi')" required>
            <yi_data_select :type="'organization'" :ids.sync="yt.editObj.orgId"></yi_data_select>
          </el-form-item>
          <el-form-item :label="$t('ziyuanbanding')">
            <el-select v-model="yt.editObj.source" multiple @change="sourceChange">
              <el-option :label="$t('chanpin')" :value="1"></el-option>
              <el-option :label="$t('muju')" :value="2"></el-option>
              <el-option :label="$t('shebei')" :value="3"></el-option>
            </el-select>
          </el-form-item>
          <el-form-item :label="$t('guanlifangshi')" required>
            <yi_dictionary_select :type="'MANAGE_TYPE'" :ids.sync="yt.editObj.manageType" @change="manageTypeChange"></yi_dictionary_select>
          </el-form-item>
          <el-form-item :label="$t('shuliang')" required>
            <el-input v-model="yt.editObj.quantity" :disabled="quantityDisabled" maxlength="9" oninput="value=value.replace(/^0|[^0-9]/g, '')"></el-input>
          </el-form-item>
          <el-form-item :label="$t('zuidashiyongcishu')">
            <el-input v-model="yt.editObj.lifespanCycles" maxlength="9" oninput="value=value.replace(/^0|[^0-9]/g, '')"></el-input>
          </el-form-item>
          <el-form-item :label="$t('danwei')" required>
            <yi_dictionary_select :type="'UNIT_CONVERSION_TYPE'" :ids.sync="yt.editObj.unit"> </yi_dictionary_select>
          </el-form-item>
          <el-form-item :label="$t('zuidashiyongshichang(xiaoshi)')">
            <el-input v-model="yt.editObj.lifespanHours" maxlength="9" oninput="value=value.replace(/^0|[^0-9]/g, '')"></el-input>
          </el-form-item>
          <el-form-item :label="$t('zhizaoshang')">
            <el-input v-model="yt.editObj.manufacturer"></el-input>
          </el-form-item>
          <el-form-item :label="$t('chufangweizhi')">
            <el-input v-model="yt.editObj.location"></el-input>
          </el-form-item>
          <el-form-item :label="$t('yuanchangxuliehao')">
            <el-input v-model="yt.editObj.manufacturerNo"></el-input>
          </el-form-item>
          <el-form-item :label="$t('shiyongzhuangtai')">
            <yi_dictionary_select type="TOOL_USAGE_STATUS" :ids.sync="yt.editObj.usageStatus"> </yi_dictionary_select>
          </el-form-item>
          <el-form-item :label="$t('dianjianzhuangtai')">
            <yi_dictionary_select type="TOOL_CHECK_POINT_STATUS" :ids.sync="yt.editObj.checkPointStatus"> </yi_dictionary_select>
          </el-form-item>
          <el-form-item :label="$t('zhongliang(KG)')">
            <yi_number_input :precision="1" :start.sync="yt.editObj.weight" :type="'number'"> </yi_number_input>
          </el-form-item>
          <el-form-item :label="$t('beizhu')">
            <el-input v-model="yt.editObj.remark"></el-input>
          </el-form-item>
        </el-form>
        <span slot="footer" class="dialog-footer">
          <el-button size="mini" @click="yt.isShowEditDialog = false">{{ $t('quxiao') }}</el-button>
          <el-button v-if="yt.editObj.action == 'xinzeng'" size="mini" :loading="yt.editObj.loading" @click="yt.req('POST', '/web/tool/create')" type="primary">
            {{ $t('baocun') }}
          </el-button>
          <el-button v-if="yt.editObj.action == 'bianji'" size="mini" :loading="yt.editObj.loading" @click="yt.req('POST', '/web/tool/update')" type="primary">
            {{ $t('baocun') }}
          </el-button>
        </span>
      </template>
      <!-- 导入工装台账 -->
      <template v-if="yt.editObj.action == 'daoru'">
        <div class="dialog-scroller">
          <yi_excel_import ref="toolImport" @loading-start="startLoading" @loading-stop="stopLoading" :templatekey="'tool_import_template_key'" :uploadApi="'/web/tool/batchImport'" />
        </div>
        <span slot="footer" class="dialog-footer">
          <el-button type="default" size="mini" @click="yt.isShowEditDialog = false">{{ $t('quxiao') }}</el-button>
          <el-button type="primary" size="mini" :loading="toolImportLoading" @click="toolImportData">{{ $t('baocun') }}</el-button>
        </span>
      </template>
      <!-- 导入工装-产品关系 -->
      <template v-if="yt.editObj.action == 'daorugongzhuangchanpinguanxi'">
        <div class="dialog-scroller">
          <yi_excel_import ref="toolProductImport" @loading-start="startLoading" @loading-stop="stopLoading" :templatekey="'tool_product_import_template_key'" :uploadApi="'/web/tool/adapt/batchImport'" />
        </div>
        <span slot="footer" class="dialog-footer">
          <el-button type="default" size="mini" @click="yt.isShowEditDialog = false">{{ $t('quxiao') }}</el-button>
          <el-button type="primary" size="mini" :loading="toolProductImportLoading" @click="toolProductImportData">{{ $t('baocun') }}</el-button>
        </span>
      </template>
      <!-- 适配对象 -->
      <template v-else-if="yt.editObj.action == 'shipeiduixiang'">
        <div class="dialog-scroller">
          <tool_adapt_index :tool="yt.editObj"></tool_adapt_index>
        </div>
      </template>
      <!-- 称重记录弹窗 -->
      <template v-else-if="yt.editObj.action == 'chengzhongjilu'">
        <div class="dialog-scroller">
          <web_mould_toll_weight_record :toolRecord="yt.editObj"></web_mould_toll_weight_record>
        </div>
      </template>
    </el-dialog>
    <!-- 二维码 -->
    <el-dialog :show-close="true" :visible.sync="isShowPrintDialog" width="400px" append-to-body="append-to-body" :before-close="closePrintDialog">
      <div v-if="isShowPrintDialog" style="height: 350px;width: 330px;margin-top: 15px">
        <div style="margin-top: 5px" :style="{ width: getDpi(90) + 'px', height: getDpi(90) + 'px' }" class="printFontFamily">
          <div id="printContent" style="text-align: center;">
            <!-- <vue-qr :text="printObj.toolNo" :margin="0" :size="250"></vue-qr> -->
            <qr-code :text="printObj.toolNo" :width="250"></qr-code>
            <div style="margin-top: 10px;font-size: 22px;color: black;">{{ printObj.toolNo }}</div>
          </div>
        </div>
      </div>
      <span slot="footer" style="display: block;text-align: center;">
        <div>
          <el-button @click="isShowPrintDialog = false" style="width: 130px;">{{ $t('quxiao') }}</el-button>
          <el-button @click="dayin()" type="primary" style="width: 130px">{{ $t('dayin') }}</el-button>
        </div>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import qrCode from '@/yi-mes/web/components/common/qr-code.vue';
import html2canvas from 'html2canvas';
import jsPDF from 'jspdf';
import tool_adapt_index from '@@/pages/web/base/tool/tool_adapt_index';
import XLSX from 'xlsx';
import web_mould_toll_weight_record from '@@/pages/web/base/tool/tool_weight_record';
export default {
  components: {
    web_mould_toll_weight_record,
    tool_adapt_index,
    qrCode
  },
  name: 'web_base_tool_list',
  data() {
    return {
      printObj: {},
      blobs: [],
      isShowPrintDialog: false,
      toolImportLoading: false,
      quantityDisabled: false,
      toolProductImportLoading: false,
      toolAdaptExportLoading: false,
      columns: [
        {
          label: 'gongzhuangbianhao',
          prop: 'toolNo'
        },
        {
          label: 'gongzhuangmingcheng',
          prop: 'toolName'
        },
        {
          label: 'gongzhuangxinghao',
          prop: 'toolSpec'
        },
        {
          label: 'gongzhuangleixing',
          prop: 'toolType',
          type: 'dictionary',
          key: 'CUSTOMER_TOOL_TYPE'
        },
        {
          label: 'guanlifangshi',
          prop: 'manageType',
          type: 'dictionary',
          key: 'MANAGE_TYPE'
        },
        {
          label: 'chufangweizhi',
          prop: 'location'
        },
        {
          label: 'shiyongzhuangtai',
          prop: 'usageStatus',
          type: 'dictionary_tag',
          key: 'TOOL_USAGE_STATUS',
          width: 150
        },
        {
          label: 'dianjianzhuangtai',
          prop: 'checkPointStatus',
          type: 'dictionary_tag',
          key: 'TOOL_CHECK_POINT_STATUS',
          width: 150
        },
        {
          label: 'shuliang',
          prop: 'quantity'
        },
        {
          label: 'danwei',
          prop: 'unit',
          type: 'dictionary',
          key: 'UNIT_CONVERSION_TYPE'
        },
        {
          label: 'zhongliang(KG)',
          prop: 'weight',
          type: 'slot'
        },
        {
          label: 'zhizaoshang',
          prop: 'manufacturer'
        },
        {
          label: 'yuanchangxuliehao',
          prop: 'manufacturerNo'
        },
        {
          label: 'zuidashiyongcishu',
          prop: 'lifespanCycles'
        },
        {
          label: 'zuidashiyongshichang(xiaoshi)',
          prop: 'lifespanHours'
        },
        {
          label: 'beizhu',
          prop: 'remark'
        },
        {
          label: 'caozuo',
          type: 'slot',
          width: 250,
          fixed: 'right'
        }
      ]
    };
  },
  created() {
    setTimeout(() => {
      this.yt.get(1);
    }, 300);
  },
  methods: {
    afterGet() {
      for (let i = 0; i < this.yt.list.length; i++) {
        this.$set(this.yt.list[i], 'source', []);
        if (this.yt.list[i].materialBindFlag) {
          this.yt.list[i].source.push(1);
        }
        if (this.yt.list[i].mouldBindFlag) {
          this.yt.list[i].source.push(2);
        }
        if (this.yt.list[i].equipmentBindFlag) {
          this.yt.list[i].source.push(3);
        }
      }
    },
    setDefaultValue() {
      this.$set(this.yt.editObj, 'manageType', '0');
      this.$set(this.yt.editObj, 'checkPointStatus', '1');
      this.quantityDisabled = false;
    },
    setEditDefaultValue() {
      if (this.yt.editObj.manageType == '1') {
        this.quantityDisabled = true;
      } else {
        this.quantityDisabled = false;
      }
    },
    sourceChange(value) {
      if (value.indexOf(1) > -1) {
        this.yt.editObj.materialBindFlag = true;
      } else {
        this.yt.editObj.materialBindFlag = false;
      }
      if (value.indexOf(2) > -1) {
        this.yt.editObj.mouldBindFlag = true;
      } else {
        this.yt.editObj.mouldBindFlag = false;
      }
      if (value.indexOf(3) > -1) {
        this.yt.editObj.equipmentBindFlag = true;
      } else {
        this.yt.editObj.equipmentBindFlag = false;
      }
    },
    manageTypeChange() {
      if (this.yt.editObj.manageType == '1') {
        this.$set(this.yt.editObj, 'quantity', '1');
        this.quantityDisabled = true;
      } else {
        this.$set(this.yt.editObj, 'quantity', '');
        this.quantityDisabled = false;
      }
    },
    startLoading() {
      this.toolImportLoading = true;
    },
    stopLoading() {
      this.toolImportLoading = false;
    },
    toolImportData() {
      let data = [...this.$refs.toolImport.tableData];
      if (data.length <= 0) {
        this.$message.error(this.$t('qingshangchuanwenjian'));
        return;
      }
      if (this.$refs.toolImport.listLength == null || this.$refs.toolImport.listLength.length == 0) {
        this.toolImportLoading = true;
        this.http
          .post('/web/tool/batchImport?onlyValidate=false', data)
          .then(response => {
            this.utils.successMessage(this.$t(response.msg));
            this.yt.isShowEditDialog = false;
            this.yt.get(1);
          })
          .catch(err => {
            this.utils.errorMessage(this.$t(err));
          })
          .finally(() => {
            this.toolImportLoading = false;
          });
      } else {
        this.utils.errorMessage(this.$t('daoruxinxiyouwu'));
      }
    },
    toolProductImportData() {
      let data = [...this.$refs.toolProductImport.tableData];
      if (data.length <= 0) {
        this.$message.error(this.$t('qingshangchuanwenjian'));
        return;
      }
      if (this.$refs.toolProductImport.listLength == null || this.$refs.toolProductImport.listLength.length == 0) {
        this.toolProductImportLoading = true;
        this.http
          .post('/web/tool/adapt/batchImport?onlyValidate=false', data)
          .then(response => {
            this.utils.successMessage(this.$t(response.msg));
            this.yt.isShowEditDialog = false;
            this.yt.get(1);
          })
          .catch(err => {
            this.utils.errorMessage(this.$t(err));
          })
          .finally(() => {
            this.toolProductImportLoading = false;
          });
      } else {
        this.utils.errorMessage(this.$t('daoruxinxiyouwu'));
      }
    },
    //导出工装-产品关系
    exportExcel() {
      this.toolAdaptExportLoading = true;
      //查询表格
      this.http
        .post('/web/tool/adapt/exportAdaptProduct?pageNum=1&pageSize=99999', { params: { ...this.yt.conditions } })
        .then(res => {
          let tableFirst = [this.$t('gongzhuangbianhao'), this.$t('chanpinbianma'), this.$t('shipeileixing'), this.$t('youxianji')];
          let tableData = [];
          tableData.push(tableFirst);
          let listData = res.data.rows;
          for (let i = 0; i < listData.length; i++) {
            let dataArr = this.getTableDataArr(listData[i]);
            tableData.push(dataArr);
          }
          const worksheet = XLSX.utils.aoa_to_sheet(tableData);
          const workbook = XLSX.utils.book_new();
          XLSX.utils.book_append_sheet(workbook, worksheet, 'Sheet1');
          XLSX.writeFile(workbook, `工装-产品关系_${this.dayjs().format('YYYYMMDDHHmmss')}.xlsx`);
        })
        .finally(() => {
          this.toolAdaptExportLoading = false;
        });
    },
    getTableDataArr(row) {
      let dataArr = [];
      dataArr[0] = row.tool ? row.tool.toolNo : '';
      dataArr[1] = row.material ? row.material.code : '';
      dataArr[2] = row.adaptType && this.$store.state.dictJson['CUSTOMER_TOOL_ADAPT_TYPE'] ? this.$t(this.$store.state.dictJson['CUSTOMER_TOOL_ADAPT_TYPE'][row.adaptType]) : '';
      dataArr[3] = row.sort;
      return dataArr;
    },

    // 打印工装编码二维码
    printToolNo(row) {
      this.printObj = this.utils.copy(row);
      this.isShowPrintDialog = true;
    },
    getDpi(num) {
      const inch = document.createElement('div');
      inch.style.width = '1in';
      document.body.appendChild(inch);
      const dpi = inch.offsetWidth;
      document.body.removeChild(inch);
      const unit = Number(num);
      const inchs = unit / 25.4;
      const px = inchs * dpi;
      return Math.round(px);
    },
    closePrintDialog() {
      this.isShowPrintDialog = false;
    },
    dayin() {
      let targetDom = document.getElementById('printContent'); //你的目标元素id
      let copyDom = targetDom.cloneNode(true); // 克隆节点
      copyDom.style.width = targetDom.offsetWidth + 'px';
      copyDom.style.height = targetDom.scrollHeight + 'PX'; // 获得高度
      document.body.appendChild(copyDom); // 插入节点

      html2canvas(copyDom).then(canvas => {
        document.body.removeChild(copyDom); // 删除节点
        let contentWidth = canvas.width;
        let contentHeight = canvas.height;
        let imgWidth = contentWidth;
        let imgHeight = contentHeight;
        let pageData = canvas.toDataURL('image/jpeg', 1.0);
        //第一个参数： l：横向  p：纵向;第二个参数：测量单位（"pt"，"mm", "cm", "m", "in" or "px"）;第三个参数：可以是下面格式，默认为“a4”
        let pdf = new jsPDF('l', 'px', [imgWidth, imgHeight]);
        pdf.addImage(pageData, 'JPEG', 0, 0, imgWidth, imgHeight);
        let pdf64 = pdf.output('blob');
        this.blobs.push(pdf64);
        this.sends();
      });
    },
    sends() {
      const formData = new FormData();
      for (let index = 0; index < this.blobs.length; index++) {
        formData.append('files[]', this.blobs[index]);
        formData.append('isVertical', 'true'); //不需要旋转图片
      }
      this.printLoading = true;
      this.http
        .post('http://127.0.0.1:9090/printLocalPDF', formData, {
          headers: {
            'Content-Type': 'multipart/form-data' // 设置请求头，确保服务器正确解析 FormData
          }
        })
        .then(res => {
          console.log(res);
          this.$message.success(this.$t('chenggong'));
        })
        .finally(() => {
          this.printLoading = false;
          this.isShowPrintDialog = false;
        });
      this.blobs = [];
    }
  }
};
</script>

<style scoped lang="scss"></style>
